import React from "react";
import { Link } from "@amzn/stencil-react-components/link";
import { Text } from "../typography";

const supportLink = (
  <Link target="_blank" href="https://amazon.com/applicationhelp">
    here
  </Link>
);

export enum ErrorCode {
  Internal = "Internal",
  E400 = "400",
  E404 = "404",
  E406 = "406",
  E409 = "409",
  E422 = "422",
  E503 = "503",
  E500 = "500",
}

export const getErrorMessage = (errorCode?: ErrorCode): React.ReactNode => {
  switch (errorCode) {
    case undefined:
      return null;

    case ErrorCode.Internal:
    case ErrorCode.E500:
    case ErrorCode.E400:
      return (
        <Text>
          The system is currently unavailable. Please try again later by
          clicking the “Retry” button below. If the issue persists, then click{" "}
          {supportLink} to contact candidate support for further assistance.
        </Text>
      );

    case ErrorCode.E404:
    case ErrorCode.E406:
      return (
        <Text>
          We are currently getting your I-9 Form ready for you. Please wait just
          2-5 minutes and check back here to get started. If your form is not
          ready within 5 minutes, please click {supportLink} to contact
          candidate support for help.
        </Text>
      );
    case ErrorCode.E503:
      return (
        <Text>
          Oops! The I-9 website is currently down for maintenance. Please check
          back here in a few hours. Thanks for your patience.
        </Text>
      );
    case ErrorCode.E409:
    default:
      return (
        <Text>
          We are unable to initiate your work authorization forms. Please click{" "}
          {supportLink} to contact candidate support and resolve this issue as
          soon as possible.
        </Text>
      );
  }
};
